import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'
import { type FiveSegment, type Group } from '~/utils'

export {
  type DisplayColumnKey,
  type DisplayRowId,
  type GroupsDiff,
  type IndividualSortColumnKey,
  type MatrixSortColumnKey,
  type QuestionsDiffsMap,
  type ScrollHash,
  type SequentialSortColumnKey,
} from '~/components/features/GroupCountsFigures'

export const pathKey = 'overlapAnalysis' satisfies PathKey

export type GroupInfo = {
  brand1: FiveSegment | 'all'
  brand2: FiveSegment | 'all'
  group: Group
}
